import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@miroculus/miroculus-ui';
const RunDetails = lazy(() => import(
/* webpackChunkName: 'run-details' */
'./RunDetails'));
const loading = React.createElement(LoadingSpinner, { message: "Loading run details..." });
const RunDetailsLoader = () => (React.createElement(Suspense, { fallback: loading },
    React.createElement(RunDetails, null)));
export default RunDetailsLoader;
